/**
 * Открыть экран Pro из любого места приложения.
 *
 * Экран один на все входы (макет docs/design/pro-2026-10-21): меняются
 * только заголовок и пример. Открывается поверх того, что человек делал, и
 * после закрытия он остаётся там же — поэтому это слой у корня, а не переход
 * на другой адрес, как прежний экран «Free и Pro».
 */
import { createContext, useContext } from 'react';
import type { ProEntry } from './pro-screen.js';

export interface ProOpen { (entry: ProEntry, opts?: { question?: string }): void }

export const ProContext = createContext<ProOpen>(() => {});

export const useOpenPro = (): ProOpen => useContext(ProContext);
